import { useRef, useEffect } from "react";

type OptionProps = {
  item: string;
  action: () => void;
};

type DropdownMenuProps = {
  options: OptionProps[];
  isOpen: boolean;
  onOutsideClickAction?: () => void;
  position?: "top" | "bottom" | "left" | "right";
};

const positionClasses = {
  top: "bottom-full left-0 mb-1",
  bottom: "top-full left-0 mt-1",
  left: "top-0 right-full mr-1",
  right: "top-0 left-full ml-1",
  default: "top-full right-0 mt-1",
};

export const DropdownMenu = ({
  options,
  isOpen,
  onOutsideClickAction,
  position = "bottom",
}: DropdownMenuProps) => {
  const menuRef = useRef<HTMLUListElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      onOutsideClickAction?.();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`absolute z-10 ${positionClasses[position] ?? positionClasses.default}`}
    >
      {isOpen && (
        <ul
          ref={menuRef}
          className="rounded bg-white border border-neutral-300 list-none p-0 m-0 min-w-48 max-w-96"
        >
          {options.map((option, index) => (
            <li
              key={index}
              onClick={option.action}
              className="py-2.5 px-3.5 rounded cursor-pointer hover:bg-neutral-100"
            >
              {option.item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};